export const basePropertiesSchema = {
  name: {
    title: 'In-page block id',
    type: 'string',
    pattern: '^[a-z][a-z0-9_-]*$',
  },
}
